import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './BlockingLoader.scss';

export default function BlockingLoader({ seleniumId = 'blocking-loader' }): React.ReactElement {
    useEffect(() => {
        const main = document.getElementById('as-main');
        const loader = document.createElement('div');
        loader.classList.add('BlockingLoader');
        main.prepend(loader);
        const root = createRoot(loader);
        root.render(
            <div className="BlockingLoaderContent" data-seleniumid={seleniumId}>
                <div className="BlockingLoaderContent--loading" />
            </div>,
        );
        return () => {
            loader.remove();
        };
    }, [seleniumId]);

    return null;
}
